var cell_default = {
  "cell": "_54FJZ",
  "header": "q776A",
  "selected": "nEpzA",
  "editing": "lnt3p",
  "singleSelection": "rYaZ5",
  "hideLastBlock": "_4-xRu",
  "editorWrapper": "wQ2DD",
  "viewerWrapper": "fIcHI",
  "hideFirstBlock": "Tu98f",
  "editor": "_1IWOr",
  "edit": "-OcVk",
  "view": "GkrtN",
  "editingToolbarWrapper": "d83p8",
  "selectAll": "mv0q-",
  "disableSelection": "Q8PWk"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
